__turbopack_context__.v({
  "productListItem": "sBJXsG_productListItem",
  "seeMoreText": "sBJXsG_seeMoreText",
});
